export class ApiError extends Error {
  constructor(
    readonly code: string,
    message: string,
    readonly status: number,
    readonly redirectMessage?: string
  ) {
    super(message);
    this.name = "ApiError";
  }
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers);
  if (init.body && !headers.has("content-type")) {
    headers.set("content-type", "application/json");
  }
  const response = await fetch(`/api${path}`, {
    ...init,
    credentials: "include",
    headers
  });
  const contentType = response.headers.get("content-type") ?? "";
  const body = contentType.includes("application/json")
    ? await response.json() as unknown
    : await response.text();

  if (!response.ok) {
    const errorBody = body && typeof body === "object" && "error" in body
      ? (body as { error?: { code?: string; message?: string; redirectMessage?: string } }).error
      : undefined;
    throw new ApiError(
      errorBody?.code ?? "request_failed",
      errorBody?.message ?? `The request could not be completed (${response.status}).`,
      response.status,
      errorBody?.redirectMessage
    );
  }
  return body as T;
}

export function apiAssetUrl(path?: string): string | undefined {
  if (!path) return undefined;
  if (path.startsWith("/api/")) return path;
  if (path.startsWith("/")) return `/api${path}`;
  return path;
}
